import type { PartnerCustomModelWrite } from '../../api.js';
import type { ThinkingLevel } from '../../types.js';

export const CUSTOM_MODEL_CAPABILITIES: Array<keyof PartnerCustomModelWrite['capabilities']> = [
  'reasoning',
  'vision',
  'toolUse',
  'streaming',
  'structuredOutput',
  'citationStrict',
  'longContext'
];

export interface PartnerCustomModelFormState {
  modelKey: string;
  displayName: string;
  description: string;
  backendId: string;
  litellmModelName: string;
  providerBaseUrl: string;
  providerApiKey: string;
  litellmBaseUrl: string;
  contextWindow: string;
  maxOutputTokens: string;
  /** Rates, as typed. `billingMode` is no longer an operator choice — it is
   *  derived from these (0/0 = free, both positive = platform-credit), which is
   *  what makes the displayed mode and actual settlement the same thing. */
  inputUsdPerMillion: string;
  outputUsdPerMillion: string;
  cachedInputUsdPerMillion: string;
  cacheWriteInputUsdPerMillion: string;
  marginMultiplier: string;
  capabilities: PartnerCustomModelWrite['capabilities'];
  thinkingLevels?: ThinkingLevel[];
}

export function defaultCustomModelForm(): PartnerCustomModelFormState {
  return {
    modelKey: '',
    displayName: '',
    description: '',
    backendId: '',
    litellmModelName: '',
    providerBaseUrl: '',
    providerApiKey: '',
    litellmBaseUrl: '',
    contextWindow: '128000',
    maxOutputTokens: '4096',
    // Defaults to free: the safe default is "records usage, deducts nothing",
    // not a positive rate nobody entered.
    inputUsdPerMillion: '0',
    outputUsdPerMillion: '0',
    cachedInputUsdPerMillion: '',
    cacheWriteInputUsdPerMillion: '',
    marginMultiplier: '1',
    capabilities: {
      reasoning: false,
      vision: false,
      toolUse: false,
      streaming: true,
      structuredOutput: false,
      citationStrict: false,
      longContext: false
    },
    thinkingLevels: ['off']
  };
}
